// Field help, the AllCode admin's half: the one centred modal a "?" opens (title, what the field
// does, a worked example, and "Read more in Help: <article>" into the Help section). Modal, not a
// tooltip or popover: a native <dialog> with a backdrop, focus trapped, Esc closes and focus returns
// to the "?" (@nexus/ui's Dialog). The copy lives in help/topics.ts; the "?" itself is
// @nexus/ui's HelpButton, which asks this provider to open the topic.
import type { ComponentChildren } from "preact";
import { useState } from "preact/hooks";
import { Dialog, HelpContext, isPlainLeftClick, useHost, type HelpId } from "@nexus/ui";
import { articleById, articleHref } from "../help/articles";
import { helpTopic } from "../help/topics";

export { HelpButton, helpButtonLabel, type HelpId } from "@nexus/ui";

export function HelpProvider({ children }: { children: ComponentChildren }) {
  const [openId, setOpenId] = useState<HelpId | null>(null);
  const host = useHost();
  const topic = openId === null ? null : helpTopic(openId);
  const article = topic ? articleById(topic.article) : null;
  const href = topic ? articleHref(topic.article, topic.section) : "/help";
  const close = () => setOpenId(null);

  return (
    <HelpContext.Provider value={{ open: setOpenId }}>
      {children}
      {topic && (
        <Dialog
          title={topic.title}
          open={true}
          onClose={close}
          class="help-dialog"
          closeLabel="Close help"
          actions={null}
        >
          <p>{topic.body}</p>
          <div class="help-example">
            <span class="help-example-label">Example</span>
            {topic.example}
          </div>
          <div class="help-dialog-foot">
            <a
              href={href}
              onClick={(event) => {
                close();
                if (!isPlainLeftClick(event)) return;
                event.preventDefault();
                host.navigate(href);
              }}
            >
              Read more in Help: {article?.title ?? "Help"}
            </a>
            <button type="button" class="button button-dark" onClick={close}>
              Got it
            </button>
          </div>
        </Dialog>
      )}
    </HelpContext.Provider>
  );
}
